<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.12.21</b> - ДВВА очка способностей за уровень теперь? ~ чтооооо ...
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Вы всё правильно услышали. Герои теперь получают не 1, а 2 очка способностей за уровень.</li>
      <li>
        Мощность Наложение швов увеличена:
        <code>20 + Уровень*(Об/6 + Лв/4)</code> -->
        <code>20 + Уровень*(Об + Лв)</code>
      </li>
      <li>
        Стоимость ОД Отравленное оружие уменьшена:
        <code>50 - Уровень</code> -->
        <code>30 - Уровень</code>
      </li>
      <li>
        При путешествии в Пещеры любые дружественные дварфы в игре теперь начнут
        впереди.
      </li>
      <li>
        Исправлены несколько багов лога боя Пещеры, таких как null/undefined имена юнитов, и сохранение
        вашей позиции при прокрутке.
      </li>
      <li>
        Ограничено количество начальных мобов Пещеры до 1~5, чтобы избежать подавления героев
        до того, как они успели забаффаться/призвать.
      </li>
    </ul>
  </div>
</template>
